// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
// @ts-nocheck
/* eslint-disable */

export const defaultHistoryType = 'browser';
export const qiankunStateFromMasterModelNamespace = '@@qiankunStateFromMaster';
